// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 此处后端没有提供注释 POST /user/admin/add */
export async function addUser(
  body: API.UserLoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.RString>("/user/admin/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/admin/agent/getAll */
export async function getAllAgentByAdmin(
  body: API.UserQueryRequest,
  options?: { [key: string]: any }
) {
  return request<API.RPageUser>("/user/admin/agent/getAll", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/admin/balance */
export async function updateBalance(
  body: API.BalanceUpdateRequest,
  options?: { [key: string]: any }
) {
  return request<API.RString>("/user/admin/balance", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/admin/login */
export async function adminLogin(
  body: API.UserLoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.RUserLoginVO>("/user/admin/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/admin/user/getAll */
export async function getAllUserByAdmin(
  body: API.UserQueryRequest,
  options?: { [key: string]: any }
) {
  return request<API.RPageUser>("/user/admin/user/getAll", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/agent/login */
export async function agentLogin(
  body: API.UserLoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.RUserLoginVO>("/user/agent/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/check */
export async function check(
  body: API.DeleteRequest,
  options?: { [key: string]: any }
) {
  return request<API.RBoolean>("/user/check", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/delete */
export async function userDelete(
  body: API.DeleteRequest,
  options?: { [key: string]: any }
) {
  return request<API.RBoolean>("/user/delete", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /user/get/login */
export async function getLogin(options?: { [key: string]: any }) {
  return request<API.RUserLoginVO>("/user/get/login", {
    method: "GET",
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/getAgentProduct */
export async function getAllAgentProductVo(
  body: API.IdRequest,
  options?: { [key: string]: any }
) {
  return request<API.RListAgentProductVO>("/user/getAgentProduct", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/getAll */
export async function getAllUser(
  body: API.UserQueryRequest,
  options?: { [key: string]: any }
) {
  return request<API.RPageUser>("/user/getAll", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/getAllUserOrders */
export async function getAllUserOrder(
  body: API.GetAllUserOrderQueryRequest,
  options?: { [key: string]: any }
) {
  return request<API.RPageUserOrderVO>("/user/getAllUserOrders", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/login */
export async function userLogin(
  body: API.UserLoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.RUserLoginVO>("/user/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /user/logout */
export async function userLogout(options?: { [key: string]: any }) {
  return request<API.RBoolean>("/user/logout", {
    method: "GET",
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/reset */
export async function userPasswordReset(
  body: API.IdRequest,
  options?: { [key: string]: any }
) {
  return request<API.RBoolean>("/user/reset", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/setAgentProduct */
export async function setAgentProduct(
  body: API.AgentProductSetRequest,
  options?: { [key: string]: any }
) {
  return request<API.RString>("/user/setAgentProduct", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /user/update */
export async function userUpdate(
  body: API.UserUpdateRequest,
  options?: { [key: string]: any }
) {
  return request<API.RBoolean>("/user/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
